/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeSystemLists.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   System Lists Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const SYSTEMLIST_LIST_CONTAINER_LOADED = 'SYSTEMLIST_LIST_CONTAINER_LOADED';
export const SYSTEMLIST_LIST_CONTAINER_UNLOADED = 'SYSTEMLIST_LIST_CONTAINER_UNLOADED';
export const SYSTEMLIST_LIST_TABLE_LOADED = 'SYSTEMLIST_LIST_TABLE_LOADED';
export const SYSTEMLIST_LIST_TABLE_UNLOADED = 'SYSTEMLIST_LIST_TABLE_UNLOADED';
export const SYSTEMLIST_LIST_CHANGE_COMPANY = 'SYSTEMLIST_LIST_CHANGE_COMPANY';
export const SYSTEMLIST_LIST_CHANGE_LISTGROUP = 'SYSTEMLIST_LIST_CHANGE_LISTGROUP';
export const SYSTEMLIST_SELECT_ROW = 'SYSTEMLIST_SELECT_ROW';
export const SYSTEMLIST_ADD = 'SYSTEMLIST_ADD';
export const SYSTEMLIST_EDIT = 'SYSTEMLIST_EDIT';
export const SYSTEMLIST_DELETE = 'SYSTEMLIST_DELETE';
export const SYSTEMLIST_DELETE_DISABLE = 'SYSTEMLIST_DELETE_DISABLE';
export const SYSTEMLIST_OPEN_WARNING = 'SYSTEMLIST_OPEN_WARNING';
export const SYSTEMLIST_CLOSE_WARNING = 'SYSTEMLIST_CLOSE_WARNING';
export const SYSTEMLIST_VIEW_LISTITEMS = 'SYSTEMLIST_VIEW_LISTITEMS';

export const SYSTEMLIST_EDIT_CONTAINER_LOADED = 'SYSTEMLIST_EDIT_CONTAINER_LOADED';
export const SYSTEMLIST_EDIT_CONTAINER_UNLOADED = 'SYSTEMLIST_EDIT_CONTAINER_UNLOADED';
export const SYSTEMLIST_EDIT_FORM_LOADED = 'SYSTEMLIST_EDIT_FORM_LOADED';
export const SYSTEMLIST_EDIT_FORM_UNLOADED = 'SYSTEMLIST_EDIT_FORM_UNLOADED';
export const SYSTEMLIST_EDIT_LOAD_LISTGROUPS = 'SYSTEMLIST_EDIT_LOAD_LISTGROUPS';
export const SYSTEMLIST_EDIT_CHANGE_COMPANY = 'SYSTEMLIST_EDIT_CHANGE_COMPANY';
export const SYSTEMLIST_EDIT_DATA_LOAD = 'SYSTEMLIST_EDIT_DATA_LOAD';
export const SYSTEMLIST_SET_COMPANY_SELECT = 'SYSTEMLIST_SET_COMPANY_SELECT';
export const SYSTEMLIST_SET_LISTGROUP_SELECT = 'SYSTEMLIST_SET_LISTGROUP_SELECT';
export const SYSTEMLIST_EDIT_CONTAINER_SUBMIT = 'SYSTEMLIST_EDIT_CONTAINER_SUBMIT';
export const SYSTEMLIST_EDIT_CONTAINER_CANCEL = 'SYSTEMLIST_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeSystemLists.js